import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from '../../base/base.value-accessor';
import { ConsultDiagnosticService } from './consult-diagnostic.service';
import { CommonCieModel } from 'src/app/model/common/cie';
import { GeneralDiagnosticViewModel } from 'src/app/model/general/diagnostic.view';

@Component({
  selector: 'ms-consult-diagnostic-item',
  templateUrl: './consult-diagnostic-item.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: ConsultDiagnosticItemComponent, multi: true }
  ]
})
export class ConsultDiagnosticItemComponent extends BaseValueAccessor<GeneralDiagnosticViewModel> {
  @Input() readonly = false;
  @Input() canRemove = false;
  @Input() idx = -1;
  @Input() turn = -1;
  @Output() remove: EventEmitter<void> = new EventEmitter();
  suggestions: CommonCieModel[] = [];

  constructor(
    protected service: ConsultDiagnosticService
  ) {
    super();
  }

  getSuggestions = (query: string) =>
    this.service.fillCieSuggestion(query).subscribe(suggestions => this.suggestions = suggestions)

  onKeyUp = (isCode: boolean = true) => {
    this.value.cie = undefined;
    if (isCode) {
      this.value.code = this.value.cieHelp?.id;
    } else {
      this.value.description = this.value.cieHelp?.description;
    }
    this.verifyCie();
  }

  fillWithSuggestion = (suggestion: CommonCieModel) => {
    // this.value.cie = suggestion.id;
    // this.value.code = suggestion.code;
    this.value.description = suggestion.description;
  }

  private verifyCie = () => {
    if (typeof (this.value.cieHelp) === 'string') {
      this.value.code = this.value.cieHelp as string;
      this.value.description = this.value.cieHelp as string;
    }
  }

}
